import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  Popconfirm,
  notification,
  message,
  Radio,
} from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { unitHandoverVacating } from "../../../constants/url";

class UnitHandoverVacatingStatus extends React.Component {
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    tableData: {
      list: [],
      loading: true,
    },
  };

  formRef = null;

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
      sorter: (a, b) => a.SN - b.SN,
    },
    {
      title: " Status Name",
      dataIndex: "StatusName",
      key: "StatusName",
      align: "center",
      width: 100,
      sorter: (a, b) => a.StatusName.localeCompare(b.StatusName),
    },
    {
      title: " Type",
      dataIndex: "Vacating_HandOver",
      key: "Vacating_HandOver",
      align: "center",
      width: 100,
      render: (value) => (value === "V" ? "Vacating" : "Handover"),
      sorter: (a, b) => a.Vacating_HandOver.localeCompare(b.Vacating_HandOver),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={() => {
                let state = this.state;
                const tempList = [];
                Object.keys(item).map((key) => {
                  tempList.push({ name: key, value: item[key] });
                  return key;
                });
                state.editFormFields = tempList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={(e) => {
                axiosInstance
                  .delete(unitHandoverVacating + "/status/" + item.StatusID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
    };
    await axiosInstance
      .get(unitHandoverVacating + "/status")
      .then((res) => {
        if (res.data.success) {
          state.tableData.list = res.data.message.map((data, index) => {
            data.SN = index + 1;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    return state;
  };

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };
  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then((values) => {
        for (let row of this.state.tableData.list)
          if (
            !this.state.editFormFields.length &&
            row.StatusName.toLowerCase() === values.StatusName.toLowerCase()
          )
            return message.error(
              "Cannot create multiple data for the same location name !"
            );
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        (this.state.editFormFields.length
          ? axiosInstance.put(unitHandoverVacating + "/status", {
              ...values,
            })
          : axiosInstance.post(unitHandoverVacating + "/status", {
              ...values,
            })
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else {
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
              this.setState({
                tableData: { list: this.state.tableData.list, loading: false },
              });
            }
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch(() => {});
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="Handover Vacating Status"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
                style={{ borderRadius: 20 }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          >
            <Form.Item
              key="StatusID"
              name="StatusID"
              label=" Status ID"
              labelAlign="left"
              labelCol={{ span: 10 }}
              hidden
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="StatusName"
              name="StatusName"
              label="Status Name"
              labelAlign="left"
              labelCol={{ span: 10 }}
              rules={[{ required: true, message: "Please enter status name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Vacating_HandOver"
              name="Vacating_HandOver"
              label="Type"
              labelAlign="left"
              labelCol={{ span: 10 }}
              rules={[{ required: true, message: "Please select type" }]}
              initialValue="V"
            >
              <Radio.Group>
                <Radio key="V" value="V">
                  Vacating
                </Radio>
                <Radio key="H" value="H">
                  Handover
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Handover Vacating Status</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 225 }}
              pagination={false}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(UnitHandoverVacatingStatus);
